import * as React from 'react';
import * as classNames from 'classnames';

interface IProps {
  name: string;
  isActive: boolean;

  onSelect: () => any;
}

export const NavTab: React.StatelessComponent<IProps> = ({name, onSelect, isActive}) => {
  return <div
    className={classNames('nav-tab', {'nav-tab_active': isActive})}
    onClick={onSelect}
  >
    {name}
  </div>;
};
